export default class DocumentNav {
  constructor(element) {
    this.$el = $(element)
    this.$trigger = this.$el.find('.document-menu__btn')
    this.$content = this.$el.find('.document-menu__wrap')
    this.init();
  }

  init() {
    const {$el, $trigger, $content} = this

    $trigger.on('click', function (e) {
      $content.toggleClass('active')
    })
  }
}
